import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { AZURE_BLOB_STORAGE } from "../../Constants"

function ZdqAzureBlobStorageConnectorStatus() {
    return <ZdqConnectorStatus vendor={AZURE_BLOB_STORAGE}></ZdqConnectorStatus>
}

export default ZdqAzureBlobStorageConnectorStatus